// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapIcon } from '../../../dsl/front';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import pl from 'dayjs/locale/pl';
let PublicationDate = class PublicationDate extends Vue {
    get date() {
        return dayjs(this.value || undefined);
    }
    get now() {
        return dayjs();
    }
    get isRecent() {
        return this.now.diff(this.date, 'hours') < 1;
    }
    get isFuture() {
        return this.date.isAfter(this.now);
    }
    get parsedDate() {
        dayjs.extend(relativeTime);
        dayjs.locale(pl);
        if (!this.date.isValid()) {
            return '';
        }
        if (this.isRecent) {
            return this.date.fromNow();
        }
        const isToday = this.date.isSame(this.now, 'day');
        return this.date.format(isToday ? 'HH:mm' : (this.shortenDate ? 'DD.MM.YYYY' : 'D MMMM YYYY, HH:mm'));
    }
};
__decorate([
    Prop({ type: String, required: false, default: null })
], PublicationDate.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], PublicationDate.prototype, "shortenDate", void 0);
PublicationDate = __decorate([
    Component({
        name: 'PublicationDate',
        components: { BootstrapIcon },
        template: `
    <time v-if="value" class="publication-date" :class="{ 'publication-date--recent': isRecent }" :datetime="value">
      {{ isFuture ? $t('modules.tile.futureDate') : parsedDate }}
    </time>
  `
    })
], PublicationDate);
export { PublicationDate };
